import { apiClient } from './apiClient';
import { Creator, Brief, SearchParams } from '../types/discover';
import { DEFAULT_AVATAR_URL, resolveAvatarUrl } from '../constants/assets';

// Mock Data
const MOCK_CREATORS: Creator[] = [
    {
        id: '1',
        name: '光影造梦师',
        handle: 'dreammaker',
        avatar: DEFAULT_AVATAR_URL,
        cover: 'https://images.unsplash.com/photo-1614850523459-c2f4c699c52e?auto=format&fit=crop&w=800&q=80',
        tags: ['广告/TVC', 'Sora', 'Runway'],
        followers: '2.5k',
        likes: '18k',
        rating: 4.9,
        reviewCount: 12,
        joinDate: '2023-10-15',
        verified: true,
        enterpriseVerified: false,
        type: 'personal' // Individual
    },
    {
        id: '2',
        name: '赛博朋克实验室',
        handle: 'cyberlab',
        avatar: 'https://images.unsplash.com/photo-1527980965255-d3b416303d12?auto=format&fit=crop&w=800&q=80',
        cover: 'https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?auto=format&fit=crop&w=800&q=80',
        tags: ['赛博朋克', 'Midjourney', '3D渲染/C4D'],
        followers: '12k',
        likes: '105k',
        rating: 4.8,
        reviewCount: 28,
        joinDate: '2023-01-20',
        verified: true,
        enterpriseVerified: true,
        type: 'studio' // Studio
    },
    {
        id: '3',
        name: '墨水流云',
        handle: 'inkflow',
        avatar: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&w=800&q=80',
        cover: 'https://images.unsplash.com/photo-1518640467707-6811f4a6ab73?auto=format&fit=crop&w=800&q=80',
        tags: ['水墨/国画', 'Stable Diffusion'],
        followers: '6.8k',
        likes: '42k',
        rating: 4.3,
        reviewCount: 7,
        joinDate: '2023-06-10',
        verified: false,
        enterpriseVerified: false,
        type: 'personal'
    },
    {
        id: '4',
        name: 'Pixel Master',
        handle: 'pixel_art',
        avatar: 'https://images.unsplash.com/photo-1570295999919-56ceb5ecca61?auto=format&fit=crop&w=800&q=80',
        cover: 'https://images.unsplash.com/photo-1550684848-fac1c5b4e853?auto=format&fit=crop&w=800&q=80',
        tags: ['像素艺术', 'Aseprite'],
        followers: '1.2k',
        likes: '5k',
        rating: 5,
        reviewCount: 3,
        joinDate: '2023-11-05',
        verified: true,
        enterpriseVerified: false,
        type: 'personal'
    },
    {
        id: '5',
        name: 'VFX Wizard',
        handle: 'vfx_wiz',
        avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&w=800&q=80',
        cover: 'https://images.unsplash.com/photo-1558655146-d09347e92766?auto=format&fit=crop&w=800&q=80',
        tags: ['VFX', 'Houdini', 'Nuke'],
        followers: '15k',
        likes: '89k',
        rating: 4.7,
        reviewCount: 19,
        joinDate: '2022-12-12',
        verified: true,
        enterpriseVerified: true,
        type: 'studio'
    },
    {
        id: 'mockuser',
        name: 'Mock 测试用户',
        handle: 'mockuser',
        avatar: 'https://images.unsplash.com/photo-1599566150163-29194dcaad36?auto=format&fit=crop&w=800&q=80',
        cover: 'https://images.unsplash.com/photo-1614850523459-c2f4c699c52e?auto=format&fit=crop&w=800&q=80',
        tags: ['独立开发者', '全栈工程师', 'AI探索者'],
        followers: '3',
        likes: '10',
        rating: 4.5,
        reviewCount: 2,
        joinDate: '2024-01-01',
        verified: true,
        enterpriseVerified: false,
        type: 'personal'
    }
];

const MOCK_BRIEFS: Brief[] = [
    {
        id: '101',
        title: '寻求国潮风格的美妆品牌 TVC 概念片',
        budget: '¥15,000 - ¥20,000',
        numericBudget: 15000,
        trialCount: 2,
        tags: ['广告/TVC', '国潮/新中式', '即梦'],
        client: '花西子官方',
        clientVerified: true,
        clientEnterpriseVerified: true,
        deadline: '7天后截止',
        deadlineDate: '2024-05-20',
        createTime: '2024-05-13',
        expectedDurationDays: 14 // 2 weeks work
    },
    {
        id: '102',
        title: '科幻短片场景概念设计',
        budget: '¥5,000 - ¥8,000',
        numericBudget: 5000,
        trialCount: 1,
        tags: ['概念设计/动态分镜', '赛博朋克', 'Midjourney'],
        client: '星际工作室',
        clientVerified: true,
        clientEnterpriseVerified: false,
        deadline: '3天后截止',
        deadlineDate: '2024-05-16',
        createTime: '2024-05-12',
        expectedDurationDays: 3 // Quick task
    },
    {
        id: '103',
        title: '3D 角色动画 MV 制作',
        budget: '¥30,000+',
        numericBudget: 30000,
        trialCount: 0,
        tags: ['MV', '3D渲染/C4D', 'Blender'],
        client: 'Indie Music',
        clientVerified: false,
        clientEnterpriseVerified: false,
        deadline: '14天后截止',
        deadlineDate: '2024-05-27',
        createTime: '2024-05-10',
        expectedDurationDays: 30 // Month work
    },
    {
        id: '104',
        title: '游戏宣传 PV 分镜绘制',
        budget: '¥10,000 - ¥15,000',
        numericBudget: 10000,
        trialCount: 3,
        tags: ['游戏', '分镜', '手绘'],
        client: 'GameStart',
        clientVerified: true,
        clientEnterpriseVerified: true,
        deadline: '5天后截止',
        deadlineDate: '2024-05-18',
        createTime: '2024-05-11',
        expectedDurationDays: 7
    },
    {
        id: '105',
        title: '产品展示 3D 渲染图',
        budget: '¥2,000 - ¥5,000',
        numericBudget: 2000,
        trialCount: 0,
        tags: ['产品渲染', 'Cinema 4D', 'Octane'],
        client: 'TechGadget',
        clientVerified: true,
        clientEnterpriseVerified: true,
        deadline: '2天后截止',
        deadlineDate: '2024-05-15',
        createTime: '2024-05-13',
        expectedDurationDays: 2
    }
];

const DEFAULT_BRIEF_AVATAR = DEFAULT_AVATAR_URL;

const buildBriefQueryString = (params: SearchParams = {}): string => {
    const queryParams = new URLSearchParams();
    if (params.sort) queryParams.append('sort', params.sort);
    if (params.limit) queryParams.append('limit', String(params.limit));
    return queryParams.toString() ? `?${queryParams.toString()}` : '';
};

const parseNumericBudget = (value?: string): number | undefined => {
    if (!value) return undefined;
    const normalized = value.replace(/[,，]/g, '').trim();
    const match = normalized.match(/([\d.]+)\s*([kwKW]?)\b/);
    if (!match) return undefined;
    const base = Number(match[1]);
    if (Number.isNaN(base)) return undefined;
    const suffix = match[2].toLowerCase();
    if (suffix === 'w') return Math.round(base * 10000);
    if (suffix === 'k') return Math.round(base * 1000);
    return Math.round(base);
};

const parseDurationDays = (value?: string): number | undefined => {
    if (!value) return undefined;
    const normalized = value.trim();
    const numberMatch = normalized.match(/([\d.]+)/);
    if (!numberMatch) return undefined;
    const amount = Number(numberMatch[1]);
    if (Number.isNaN(amount)) return undefined;

    if (/周/.test(normalized)) return Math.round(amount * 7);
    if (/月/.test(normalized)) return Math.round(amount * 30);
    return Math.round(amount);
};

const parseDateLabel = (value?: string): string => {
    if (!value) return '可谈';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return value;
    return date.toISOString().slice(0, 10);
};

const normalizeBudgetLabel = (value?: string): string => {
    if (!value || value.trim() === '') return '可谈';
    const normalized = value.trim();
    if (normalized === '可谈') return normalized;
    if (/[¥￥]/.test(normalized)) return normalized.replace('￥', '¥');
    return /^[-\d.]/.test(normalized) ? `¥${normalized}` : normalized;
};

const extractBriefArray = (payload: any): any[] => {
    if (!payload) return [];
    if (Array.isArray(payload)) return payload;
    if (Array.isArray(payload.briefs)) return payload.briefs;
    if (Array.isArray(payload.data?.briefs)) return payload.data.briefs;
    if (Array.isArray(payload.data)) return payload.data;
    return [];
};

const extractSingleBrief = (payload: any): any | null => {
    if (!payload) return null;
    if (payload.brief) return payload.brief;
    if (payload.data?.brief) return payload.data.brief;
    if (payload.data && !Array.isArray(payload.data)) return payload.data;
    return payload;
};

const LEGACY_DISCOVER_DEFAULT_COVER = 'images.unsplash.com/photo-1614850523459-c2f4c699c52e';

const normalizeCreatorCover = (coverUrl?: string | null): string => {
    const value = String(coverUrl || '').trim().replace(/^http:\/\//, 'https://');
    return value.includes(LEGACY_DISCOVER_DEFAULT_COVER) ? '' : value;
};

const normalizeCreator = (creator: any): Creator => ({
    ...creator,
    id: String(creator.id || creator.userId),
    avatar: resolveAvatarUrl(creator.avatar || creator.avatarUrl),
    cover: normalizeCreatorCover(creator.cover || creator.coverImageUrl),
    isOfficial: Boolean(creator.isOfficial),
    enterpriseVerified: Boolean(creator.enterpriseVerified)
});

const normalizeBrief = (brief: any): Brief => {
    const clientInfo = brief.client && typeof brief.client === 'object' ? brief.client : undefined;
    const publisher = brief.publisher || clientInfo?.displayName || clientInfo?.username || brief.client || '匿名需求方';
    const avatar = resolveAvatarUrl(brief.avatar || clientInfo?.avatarUrl || DEFAULT_BRIEF_AVATAR);
    const deliveryTimeRange = brief.deliveryTimeRange || brief.duration || '可谈';
    const targetDate = brief.targetDate || brief.deadlineDate || brief.deadline || '';
    const createTime = brief.createTime || brief.createdAt || targetDate || new Date().toISOString();
    const budget = normalizeBudgetLabel(brief.budget || brief.budgetRange || '可谈');
    const numericBudget = typeof brief.numericBudget === 'number'
        ? brief.numericBudget
        : parseNumericBudget(budget);

    return {
        id: String(brief.id),
        title: brief.title || '未命名需求',
        budget,
        numericBudget,
        trialCount: brief.trialCount ?? 0,
        communicationCount: brief.communicationCount ?? 0,
        viewCount: brief.viewCount ?? 0,
        tags: Array.isArray(brief.tags) ? brief.tags : [],
        client: publisher,
        publisher,
        avatar,
        clientVerified: brief.clientVerified ?? clientInfo?.verified ?? false,
        clientEnterpriseVerified: brief.clientEnterpriseVerified ?? (clientInfo?.accountType === 'company') ?? false,
        clientUserId: brief.clientUserId || clientInfo?.userId || undefined,
        deadline: brief.deadline || parseDateLabel(targetDate),
        deadlineDate: brief.deadlineDate || targetDate || undefined,
        createTime,
        expectedDurationDays: brief.expectedDurationDays ?? parseDurationDays(deliveryTimeRange),
        description: brief.description,
        deliverables: brief.deliverables,
        status: brief.status
    };
};

export const discoverService = {
    /**
     * Fetch creators from API or fallback to mock
     */
    getCreators: async (params: SearchParams): Promise<Creator[]> => {
        try {
            const queryParams = new URLSearchParams();
            if (params.limit) queryParams.append('limit', String(params.limit));
            const queryString = queryParams.toString() ? `?${queryParams.toString()}` : '';
            const response = await apiClient.get<{ creators: Creator[] }>(`/api/v1/discover/creators${queryString}`);
            if (response.success && response.data?.creators) {
                return response.data.creators.map(normalizeCreator);
            }
            return [];
        } catch (error) {
            console.error('Failed to fetch real creators:', error);
            return [];
        }
    },

    getTopCreators: async (params: { limit?: number; minReviews?: number } = {}): Promise<Creator[]> => {
        try {
            const queryParams = new URLSearchParams();
            if (params.limit !== undefined) queryParams.append('limit', String(params.limit));
            if (params.minReviews !== undefined) queryParams.append('minReviews', String(params.minReviews));
            const queryString = queryParams.toString() ? `?${queryParams.toString()}` : '';
            const response = await apiClient.get<{ creators: Creator[] }>(`/api/v1/discover/top-creators${queryString}`);
            if (response.success && response.data?.creators) {
                return response.data.creators.map(normalizeCreator);
            }
            return [];
        } catch (error) {
            console.error('Failed to fetch top creators:', error);
            return [];
        }
    },

    /**
     * Fetch briefs from API or fallback to mock
     */
    getBriefs: async (params: SearchParams = {}): Promise<Brief[]> => {
        try {
            const response = await apiClient.get<{ briefs: Brief[] }>(`/api/v1/discover/briefs${buildBriefQueryString(params)}`);
            if (response.success) {
                const payload = response.data as any;
                const rawBriefs = extractBriefArray(payload);
                if (rawBriefs.length > 0) {
                    return rawBriefs.map(normalizeBrief);
                }
            }
            return [];
        } catch (error) {
            console.error('Failed to fetch real briefs:', error);
            return [];
        }
    },

    /**
     * Track a view for a brief detail page.
     */
    incrementBriefView: async (briefId: string): Promise<void> => {
        try {
            await apiClient.post(`/api/v1/briefs/${briefId}/view`, {});
        } catch (error) {
            console.error('Failed to track brief view:', error);
        }
    },

    /**
     * Normalize a single brief payload.
     */
    normalizeBrief: (brief: any): Brief | null => {
        const normalized = extractSingleBrief(brief);
        return normalized ? normalizeBrief(normalized) : null;
    },

    getPopularTags: async (): Promise<{ name: string; count: number }[]> => {
        try {
            const response = await apiClient.get<{ name: string; count: number }[]>('/api/v1/discover/popular-tags');
            if (response.success) {
                const data = (response.data as any)?.data || response.data;
                return Array.isArray(data) ? data : [];
            }
            return [];
        } catch { return []; }
    },
};
